import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Snackbar from "@material-ui/core/Snackbar";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
// import GoodsCost from "./goods-cost.component";
import {
  Upload,
  GetAllBrands,
  GetGoodsTypes,
  GetSubCategoriesByBrand,
  AddProduct,
  GetProduct,
  EditProduct,
  GetAllCities,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./product.styles.css";
import { Close } from "@material-ui/icons";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captionCount: "",
      captionCountHelper: "",
      brandId: "",

      goodsTypeId: "",

      subCategoryId: "",

      name: "",
      nameHelper: "",
      imageAddress: "",
      liter: "",
      literHelper: "",
      countInPack: 0,
      countInPackHelper: "",
      description: "",
      mostSell: false,
      mostOff: false,
      // goodsCosts: [],
      brands: [],
      goodsTypes: [],
      subCategories: [],
      cities: [],
      loading: false,
      saving: false,
      uploadPic: false,
      uploadPics: false,
      openSnackbar: false,
      errorMessage: "",
      // ----------------------------
      gallery: [],
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    GetAllBrands()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ brands: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });

    GetGoodsTypes()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ goodsTypes: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });

    GetAllCities()
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });

    const productId = this.props.match.params.productId;
    if (productId) {
      this.loadProduct(productId);
    }
  }

  loadProduct = (productId) => {
    this.setState({ loading: true });
    GetProduct(productId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            captionCount: responseJson.product.captionCount,
            brandId: responseJson.product.brandId,
            goodsTypeId: responseJson.product.goodsTypeId,
            subCategoryId: responseJson.product.subCategoryId,
            name: responseJson.product.name,
            liter: responseJson.product.liter,
            description: responseJson.product.description,
            // goodsCosts: responseJson.goodsCosts,
            countInPack: responseJson.product.countInPack,
            mostSell: responseJson.product.mostSell,
            mostOff: responseJson.product.mostOff,
            imageAddress: responseJson.product.imageAddress,
            // -------------------------------------------
            gallery: responseJson.product.gallery,
          });
        this.getSubCategoriesByBrand();
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (this.props.match.params.productId) {
      EditProduct({
        captionCount: this.state.captionCount,
        brandId: this.state.brandId,
        goodsTypeId: this.state.goodsTypeId,
        subCategoryId: this.state.subCategoryId,
        name: this.state.name,
        imageAddress: this.state.imageAddress,
        liter: this.state.liter,
        description: this.state.description,
        // goodsCosts: this.state.goodsCosts,
        countInPack: this.state.countInPack,
        mostSell: this.state.mostSell,
        mostOff: this.state.mostOff,
        Id: this.props.match.params.productId,
        // ---------------------------------
        gallery: this.state.gallery,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای ویرایش شدن محصول");
          } else if (response.status === 200) {
            toast.success("محصول با موفقیت ویرایش شد");
            this.props.history.push("/main/products");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddProduct({
        captionCount: this.state.captionCount,
        brandId: this.state.brandId,
        goodsTypeId: this.state.goodsTypeId,
        subCategoryId: this.state.subCategoryId,
        name: this.state.name,
        liter: this.state.liter,
        description: this.state.description,
        // goodsCosts: this.state.goodsCosts,
        countInPack: this.state.countInPack,
        mostSell: this.state.mostSell,
        mostOff: this.state.mostOff,
        imageAddress: this.state.imageAddress,
        // --------------------------------------
        gallery: this.state.gallery,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای اضافه شدن محصول");
          } else if (response.status === 200) {
            toast.success("محصول با موفقیت اضافه شد");
            this.props.history.push("/main/products");
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleChangeBrand = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getSubCategoriesByBrand();
    });
  };

  getSubCategoriesByBrand = () => {
    // if (!this.props.match.params.productId) {
    GetSubCategoriesByBrand(this.state.brandId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ subCategories: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleRemovePic = (index) => {
    this.setState((state) => {
      const pics = state.pics.filter((item, j) => index !== j);
      return {
        pics,
      };
    });
  };

  handleSelectFile = (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })

      .then((responseJson) => {
        this.setState({ imageAddress: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // ---------------------------------------------------------------

  handleSelectFiles = (event) => {
    // console.log("🚀 ~ Product ~ event:", event);

    const files = event.target.files;
    if (files.length > 0) {
      this.setState({ uploadPics: true });

      const uploadPromises = Array.from(files).map((file) =>
        Upload(file, "goods").then((response) => response.text())
      );

      Promise.all(uploadPromises)
        .then((addresses) => {
          this.setState((prevState) => ({
            gallery: [...prevState.gallery, ...addresses],
            uploadPics: false,
          }));
        })
        .catch((error) => {
          console.error(error);
          this.setState({ uploadPics: false });
        });
    }
    // console.log("🚀 ~ Product ~ files:", files);
  };

  handleDeleteImage = (index) => {
    const updatedGallery = [...this.state.gallery];
    updatedGallery.splice(index, 1);
    this.setState({ gallery: updatedGallery });
  };

  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }

        break;
      case "liter":
        this.setState({ liter: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({
            literHelper: "لطفا مقدار بر حسب لیتر  را عدد وارد کنید ",
          });
        } else {
          this.setState({ literHelper: "" });
        }

        break;
      case "countInPack":
        this.setState({ countInPack: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({
            countInPackHelper: "لطفا تعداد در هر کارتن را عدد وارد کنید",
          });
        } else {
          this.setState({ countInPackHelper: "" });
        }

        break;

        break;

      case "captionCount":
        this.setState({ captionCount: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            captionCountHelper: "لطفا عنوان واحد را وارد کنید",
          });
        } else {
          this.setState({ captionCountHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.productId ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش محصول
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن محصول جدید
              </Typography>
            )}
            <Grid container>
              <Grid item md={12}>
                <React.Fragment>
                  <form
                    className={classes.container}
                    noValidate
                    autoComplete="off"
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={
                            this.state.goodsTypeId.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.goodsTypeId.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id="goodsTypeId"
                          select
                          label="دسته بندی"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.goodsTypeId}
                          onChange={this.handleChange("goodsTypeId")}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.goodsTypes.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={
                            this.state.brandId.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.brandId.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id="standard-select-brand"
                          select
                          label="برند"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.brandId}
                          onChange={this.handleChangeBrand("brandId")}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.brands.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="subCategoryId"
                          select
                          label="زیر برند"
                          fullWidth
                          name="subCategoryId"
                          className={classes.textField}
                          value={this.state.subCategoryId}
                          onChange={this.handleChange("subCategoryId")}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.subCategories.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.nameHelper.length !== 0}
                          helperText={this.state.nameHelper}
                          onChange={this.onchange}
                          id="name"
                          label="نام"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.name}
                          margin="normal"
                          InputLabelProps={
                            this.state.name.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.name.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.literHelper.length !== 0}
                          helperText={this.state.literHelper}
                          onChange={this.onchange}
                          InputLabelProps={
                            this.state.liter.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.liter.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id="liter"
                          label="مقدار (بر حسب لیتر)"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.liter}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.countInPackHelper.length !== 0}
                          helperText={this.state.countInPackHelper}
                          onChange={this.onchange}
                          InputLabelProps={
                            this.state.countInPack.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.countInPack.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id="countInPack"
                          label="تعداد در هر کارتن"
                          fullWidth
                          className={classes.textField}
                          value={this.state.countInPack}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          error={this.state.captionCountHelper.length !== 0}
                          helperText={this.state.captionCountHelper}
                          onChange={this.onchange}
                          InputLabelProps={
                            this.state.captionCount &&
                            this.state.captionCount.length === 0
                              ? {
                                  classes: {
                                    root: classes.cssLabel,
                                  },
                                  FormLabelClasses: {
                                    asterisk: classes.labelAsterisk,
                                  },
                                }
                              : ""
                          }
                          InputProps={
                            this.state.captionCount &&
                            this.state.captionCount.length === 0
                              ? {
                                  classes: {
                                    underline: classes.cssRequired,
                                  },
                                }
                              : ""
                          }
                          id="captionCount"
                          label="عنوان واحد"
                          fullWidth
                          className={classes.textField}
                          value={this.state.captionCount}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-description"
                          label="توضیحات"
                          fullWidth
                          multiline
                          rows="4"
                          className={classes.textField}
                          value={this.state.description}
                          onChange={this.handleChange("description")}
                          margin="normal"
                        />
                      </Grid>

                      {/* ---------------------------------single image------------------------------- */}
                      <Grid item xs={12} align={"right"}>
                        <div>
                          <input
                            accept="image/*"
                            className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-file"
                            multiple
                            type="file"
                            onChange={this.handleSelectFile}
                          />
                          <label htmlFor="raised-button-file">
                            <Button
                              fullWidth
                              variant="contained"
                              component="span"
                              className={classes.button}
                            >
                              ارسال عکس
                            </Button>
                            {this.state.uploadPic && (
                              <CircularProgress
                                size={24}
                                className={classes.buttonProgress}
                              />
                            )}
                          </label>
                        </div>
                        <div>
                          <div className="picParent">
                            <img
                              src={`http://test.asa-oil.ir/${this.state.imageAddress}`}
                              className="picture"
                              alt={this.state.name}
                            />
                          </div>
                        </div>
                      </Grid>
                      {/* -----------------------------------Gallery image-------------------------------------------- */}
                      <Grid item xs={12} align={"right"}>
                        <div>
                          <input
                            accept="image/*"
                            className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-files"
                            multiple
                            type="file"
                            onChange={this.handleSelectFiles}
                          />
                          <label htmlFor="raised-button-files">
                            <Button
                              fullWidth
                              variant="contained"
                              component="span"
                              className={` btnGalleryStyle`}
                            >
                              {this.state.uploadPics ? (
                                <span>در حال بارگزاری ...</span>
                              ) : (
                                "ایحاد گالری برای محصول"
                              )}
                            </Button>
                          </label>
                        </div>
                        <div className="picParent">
                          {this.state.gallery.map((image, index) => (
                            <div
                              key={index}
                              style={{
                                position: "relative",
                                display: "inline-block",
                                margin: "10px",
                                marginTop: "15px",
                              }}
                            >
                              <img
                                src={`http://test.asa-oil.ir/${image}`}
                                className="pictures-gallery"
                                alt={`Image ${index + 1}`}
                              />
                              <button
                                className="removeBtn"
                                onClick={() => this.handleDeleteImage(index)}
                              >
                                <Close
                                  style={{
                                    color: "#ffff",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                              </button>
                            </div>
                          ))}
                        </div>
                      </Grid>

                      {/* -----------------------------------Gallery image-------------------------------------------- */}

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.mostSell}
                            onChange={this.handleCheckChange("mostSell")}
                            value="MostSell"
                            color="primary"
                          />
                        }
                        label="پر فروشترین"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.mostOff}
                            onChange={this.handleCheckChange("mostOff")}
                            value="MostOff"
                            color="primary"
                          />
                        }
                        label="پر تخفیف ترین"
                      />
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={
                            this.state.loading ||
                            this.state.nameHelper.length !== 0 ||
                            (this.state.name && this.state.name.length === 0) ||
                            this.state.literHelper.length !== 0 ||
                            (this.state.liter &&
                              this.state.liter.length === 0) ||
                            this.state.countInPackHelper.length !== 0 ||
                            (this.state.countInPack &&
                              this.state.countInPack.length === 0) ||
                            this.state.captionCountHelper.length !== 0 ||
                            (this.state.captionCount &&
                              this.state.captionCount.length === 0) ||
                            this.state.goodsTypeId.length === 0 ||
                            this.state.brandId.length === 0
                          }
                          onClick={this.handleSave}
                        >
                          ذخیره
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
            </Grid>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Product.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Product));
